/** Client-side presentation helpers built on the shared config. */
import { ACTION_META, type Action } from "../shared/types";

export function actionLabel(a: Action): string {
  return ACTION_META[a].label;
}

/** Meter color: black under the review threshold, amber at review, red at action. */
export function hazardBarColor(p: number): string {
  if (p >= 0.7) return "var(--malicious)";
  if (p >= 0.35) return "var(--suspicious)";
  return "var(--ink)";
}
